import cover1 from './cover/httpswww.twitch.tvvideos2497454551t=2h57m41s.jpg';
import cover2 from './cover/httpswww.twitch.tvvideos2490174878t=2h41m17s.jpg';
import cover3 from './cover/httpswww.youtube.comwatchv=8hpXkniByp0&ab_channel=Granty.jpg';
import cover4 from './cover/httpswww.youtube.comwatchv=V8m9AMxMG6g&ab_channel=Juztify.jpg';

const videoCover = [
  cover1, cover2, cover3, cover4
];

export default videoCover;
